<!-- eslint-disable -->
<template>
  <div class="page-icar-order">
    <sb-headline :title="'ICAR订单'"></sb-headline>

    <div class="search-container">
      <div class="search-header">
        <div class="search-icon">
          <i class="el-icon-search"></i>
        </div>
        <div class="search-title">订单筛选</div>
        <div class="tabs-container">
          <el-tabs v-model="selectTab" @tab-click="pageHandler(params, 1)" class="tab-wrapper">
            <el-tab-pane
              v-for="(item, index) in tabList"
              :key="index"
              :label="item.stageName+'('+item.count+')'"
              :name="item.stage+''"
            ></el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div class="search-wrapper">
        <el-form :inline="true" :model="searchData" label-position="left" class="search-form">
          <el-form-item>
            <el-input v-model="searchData.searchKeyword" placeholder="姓名/手机/证件号" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchData.vin" placeholder="VIN" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchData.orderStatus" placeholder="订单状态" size="small" clearable>
              <el-option label="待交车" value="1"></el-option>
              <el-option label="已交车" value="2"></el-option>
              <el-option label="已退订" value="4"></el-option>
              <el-option label="已退货" value="5"></el-option>
              <el-option label="退订审批中" value="6"></el-option>
              <el-option label="退货审批中" value="7"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchData.orderType" placeholder="订单类型" size="small" clearable>
              <el-option label="手动下订" value="0"></el-option>
              <el-option label="商城订单" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchData.saleConsultantName" placeholder="销售顾问" size="small" clearable></el-input>
          </el-form-item>

          <el-form-item>
            <el-input v-model="searchData.dealerName" placeholder="所属经销商" size="small" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchData.offlineChargebacks" placeholder="是否线下退单" size="small" clearable>
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="交车时间" label-width="70px" size="small">
            <el-date-picker
              v-model="searchData.deliveryStartTime"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              value-format="yyyy-MM-dd"
              size="small"
            ></el-date-picker>
          </el-form-item>

          <el-collapse-transition>
            <div v-if="operBtnFlag" class="advanced-search">
              <el-form-item label="下单时间" label-width="70px" size="small">
                <el-date-picker
                  v-model="searchData.depositStartTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  size="small"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="退订审核通过时间" label-width="120px" size="small">
                <el-date-picker
                  v-model="searchData.cancelDepositStartTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  size="small"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="退货审核通过时间" label-width="120px" size="small">
                <el-date-picker
                  v-model="searchData.returnCarAuditRejectStartTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  size="small"
                ></el-date-picker>
              </el-form-item>
            </div>
          </el-collapse-transition>

          <div class="search-actions">
            <el-button @click="resetSearchData" size="small" plain>重置</el-button>
            <el-button @click="pageHandler(params, 1)" type="primary" size="small">查询</el-button>
            <el-button type="text" @click="operBtnHandle" class="expand-btn">
              {{operBtnText}}<i :class="operBtnClas"></i>
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <div class="main-container">
      <div class="table">
        <div class="operate-bar">
          <div class="table-title">
            <i class="el-icon-tickets"></i> 订单列表 <span class="count">(共 {{ customerTotal }} 条)</span>
          </div>
          <div class="table-actions">
            <el-button size="small" icon="el-icon-refresh-left" @click="updateUserFn" circle title="刷新数据"></el-button>
          </div>
        </div>

        <my-table ref="list" :data="listData" @page="pageHandler" :listLoading="listLoading" class="icar-table" border-none>
          <el-table-column
            v-if="orderCodeColumn"
            :label="orderCodeColumn.label"
            :prop="orderCodeColumn.prop"
            :min-width="orderCodeColumn.width"
          >
            <template slot-scope="scope">
              <div class="order-no-cell" @click="openUserInfoFn(scope.row)">
                <span class="no-text">{{ scope.row.orderCode }}</span>
                <i class="el-icon-arrow-right view-detail-icon"></i>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-if="orderTypeColumn"
            :label="orderTypeColumn.label"
            :prop="orderTypeColumn.prop"
            :min-width="orderTypeColumn.width"
          >
            <template slot-scope="scope">
              {{ scope.row.orderType | orderTypeFormatter}}
            </template>
          </el-table-column>

          <el-table-column
            v-if="orderStatusColumn"
            :label="orderStatusColumn.label"
            :prop="orderStatusColumn.prop"
            :min-width="orderStatusColumn.width"
          >
            <template slot-scope="scope">
              <div class="order-status-badge" :class="getStatusClass(scope.row.orderStatus)">
                <i class="status-icon" :class="getStatusIcon(scope.row.orderStatus)"></i>
                <span>{{ scope.row.orderStatus | orderStatusFormatter}}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            v-for="item in visibleColumns"
            :key="item.prop"
            :label="item.label"
            :prop="item.prop"
            :min-width="item.width"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <div v-if="scope.row[item.prop] || scope.row[item.prop] === 0">
                <!-- 客户姓名脱敏处理 -->
                <template v-if="item.prop === 'customerName'">
                  <span class="sensitive-data" @click="toggleSensitiveInfo(scope.row.orderCode, 'name')">
                    <span v-if="shouldShowSensitiveInfo(scope.row.orderCode, 'name')">
                      {{scope.row.customerName}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                    <span v-else>
                      {{maskName(scope.row.customerName)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                  </span>
                </template>

                <!-- 手机号脱敏处理 -->
                <template v-else-if="item.prop === 'phone'">
                  <span class="sensitive-data" @click="toggleSensitiveInfo(scope.row.orderCode, 'phone')">
                    <span v-if="shouldShowSensitiveInfo(scope.row.orderCode, 'phone')">
                      {{scope.row.phone}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                    <span v-else>
                      {{maskPhone(scope.row.phone)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                  </span>
                </template>

                <!-- 证件号脱敏处理 -->
                <template v-else-if="item.prop === 'certificateNumber'">
                  <span class="sensitive-data" @click="toggleSensitiveInfo(scope.row.orderCode, 'certificate')">
                    <span v-if="shouldShowSensitiveInfo(scope.row.orderCode, 'certificate')">
                      {{scope.row.certificateNumber}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                    <span v-else>
                      {{maskCertificate(scope.row.certificateNumber)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                  </span>
                </template>

                <!-- 性别格式化 -->
                <template v-else-if="item.prop === 'gender'">
                  {{ scope.row.gender | genderFormatter }}
                </template>

                <!-- 退订审核通过时间特殊处理 -->
                <template v-else-if="item.prop === 'cancelDepositTime'">
                  <span>{{scope.row.cancelDepositTime || '--'}}</span>
                </template>

                <!-- 退货审核通过时间特殊处理 -->
                <template v-else-if="item.prop === 'returnCarAuditPassTime'">
                  <span>{{scope.row.returnCarAuditPassTime || '--'}}</span>
                </template>

                <!-- 其他普通字段 -->
                <template v-else>
                  {{scope.row[item.prop]}}
                </template>
              </div>
              <div v-else>--</div>
            </template>
          </el-table-column>
        </my-table>
      </div>
    </div>

    <!-- 保持原有抽屉组件的内容，但使用更紧凑的布局 -->
    <el-drawer :visible.sync="userInfoDrawer" :with-header="false" size="70%" class="order-detail-drawer">
      <el-container class="container_box">
        <!-- 头部基础信息 -->
        <el-header class="container_box_head" height="auto">
          <div class="section-title">
            <i class="el-icon-user"></i> 客户基础信息
          </div>

          <div class="info-grid">
            <div class="info-item">
              <span class="label">订单编号：</span>
              <span class="value highlight">{{orderDetailData.orderCode }}</span>
            </div>
            <div class="info-item">
              <span class="label">客户名称：</span>
              <span class="value sensitive-data" @click="toggleSensitiveInfo(orderDetailData.orderCode, 'name_detail')">
                <span v-if="shouldShowSensitiveInfo(orderDetailData.orderCode, 'name_detail')">
                  {{emptyToLine(orderDetailData.customerName)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
                <span v-else>
                  {{maskName(orderDetailData.customerName)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
              </span>
            </div>
            <div class="info-item">
              <span class="label">手机号：</span>
              <span class="value sensitive-data" @click="toggleSensitiveInfo(orderDetailData.orderCode, 'phone_detail')">
                <span v-if="shouldShowSensitiveInfo(orderDetailData.orderCode, 'phone_detail')">
                  {{emptyToLine(orderDetailData.phone)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
                <span v-else>
                  {{maskPhone(orderDetailData.phone)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
              </span>
            </div>
            <div class="info-item">
              <span class="label">证件号：</span>
              <span class="value sensitive-data" @click="toggleSensitiveInfo(orderDetailData.orderCode, 'certificate_detail')">
                <span v-if="shouldShowSensitiveInfo(orderDetailData.orderCode, 'certificate_detail')">
                  {{emptyToLine(orderDetailData.certificateNumber)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
                <span v-else>
                  {{maskCertificate(orderDetailData.certificateNumber)}}
                  <i class="el-icon-view sensitive-icon"></i>
                </span>
              </span>
            </div>
            <div class="info-item">
              <span class="label">性别：</span>
              <span class="value">{{orderDetailData.gender | genderFormatter}}</span>
            </div>
            <div class="info-item">
              <span class="label">出生日期：</span>
              <span class="value">{{emptyToLine(orderDetailData.birthday)}}</span>
            </div>
            <div class="info-item">
              <span class="label">省市区：</span>
              <span class="value">{{
                  emptyToLine(orderDetailData.province)+ "/" +
                  emptyToLine(orderDetailData.city)+ "/" +
                  emptyToLine(orderDetailData.district)
              }}</span>
            </div>
            <div class="info-item">
              <span class="label">详细地址：</span>
              <span class="value">{{emptyToLine(orderDetailData.address)}}</span>
            </div>
            <div class="info-item">
              <span class="label">婚姻状况：</span>
              <span class="value">{{orderDetailData.maritalStatus | maritalStatusFormatter}}</span>
            </div>
            <div class="info-item">
              <span class="label">学历：</span>
              <span class="value">{{orderDetailData.educationLevel | educationLevelFormatter}}</span>
            </div>
            <div class="info-item">
              <span class="label">收入：</span>
              <span class="value">{{orderDetailData.incomeLevel | incomeLevelFormatter}}</span>
            </div>
            <div class="info-item">
              <span class="label">行业：</span>
              <span class="value">{{orderDetailData.businessType | businessTypeFormatter}}</span>
            </div>
            <div class="info-item">
              <span class="label">兴趣爱好：</span>
              <span class="value">{{emptyToLine(orderDetailData.interest)}}</span>
            </div>
            <div class="info-item">
              <span class="label">首触渠道：</span>
              <span class="value">{{emptyToLine(orderDetailData.channelName)}}</span>
            </div>
            <div class="info-item">
              <span class="label">销售顾问：</span>
              <span class="value">{{emptyToLine(orderDetailData.saleConsultantName)}}</span>
            </div>
            <div class="info-item">
              <span class="label">所属经销商：</span>
              <span class="value">{{emptyToLine(orderDetailData.dealerName)}}</span>
            </div>
            <div class="info-item">
              <span class="label">是否线下退单：</span>
              <span class="value">{{orderDetailData.offlineChargebacks}}</span>
            </div>
            <div class="info-item">
              <span class="label">退订审核通过时间：</span>
              <span class="value">{{emptyToLine(orderDetailData.cancelDepositPassTime)}}</span>
            </div>
            <div class="info-item">
              <span class="label">退货审核通过时间：</span>
              <span class="value">{{emptyToLine(orderDetailData.returnCarAuditPassTime)}}</span>
            </div>
          </div>
        </el-header>

        <el-container>
          <el-main class="container_box_main">
            <el-tabs class="container_box_main_tabs" v-model="selectMainTab" type="card" @tab-click="maintabHandleClick">
              <el-tab-pane label="下单信息" name="1"></el-tab-pane>
              <el-tab-pane label="成交信息" name="2"></el-tab-pane>
              <el-tab-pane label="操作记录" name="3"></el-tab-pane>
            </el-tabs>

            <div class="container_box_main_content" v-if="selectMainTab==1">
              <div v-if="orderDetailData" class="info-grid">
                <div class="info-item">
                  <span class="label">下订时间：</span>
                  <span class="value">{{orderDetailData.depositTime }}</span>
                </div>
                <div class="info-item">
                  <span class="label">订单类型：</span>
                  <span class="value">{{orderDetailData.orderType | orderTypeFormatter}}</span>
                </div>
                <div class="info-item">
                  <span class="label">商城订单状态：</span>
                  <span class="value">{{orderDetailData.mallOrderStatus}}</span>
                </div>
                <div class="info-item">
                  <span class="label">订金：</span>
                  <span class="value">{{orderDetailData.depositAmount }} 元</span>
                </div>
                <div class="info-item">
                  <span class="label">订金类型：</span>
                  <span class="value">{{orderDetailData.depositType | depositTypeFormatter}}</span>
                </div>
                <div class="info-item">
                  <span class="label">下订证件号：</span>
                  <span class="value sensitive-data" @click="toggleSensitiveInfo(orderDetailData.orderCode, 'deposit_certificate')">
                    <span v-if="shouldShowSensitiveInfo(orderDetailData.orderCode, 'deposit_certificate')">
                      {{emptyToLine(orderDetailData.depositCertificateNumber)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                    <span v-else>
                      {{maskCertificate(orderDetailData.depositCertificateNumber)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">下订证件类型：</span>
                  <span class="value">{{ orderDetailData.depositCertificateType |certificateTypeFormatter }}</span>
                </div>
                <div class="info-item">
                  <span class="label">计划交车时间：</span>
                  <span class="value">{{emptyToLine(orderDetailData.planDeliveryTime)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">下订车型：</span>
                  <span class="value">{{emptyToLine(orderDetailData.carModelName)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">颜色：</span>
                  <span class="value">{{orderDetailData.carColorName }}</span>
                </div>
                <div class="info-item">
                  <span class="label">付款方式：</span>
                  <span class="value">{{orderDetailData.paymentType | paymentTypeFormatter}}</span>
                </div>
                <div class="info-item">
                  <span class="label">协议方式：</span>
                  <span class="value">{{orderDetailData.protocolType}}</span>
                </div>
                <div class="info-item">
                  <span class="label">接待录音：</span>
                  <span class="value">{{ emptyToLine()}}</span>
                </div>
                <div class="info-item">
                  <span class="label">备注：</span>
                  <span class="value">{{emptyToLine(orderDetailData.remark)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">附件：</span>
                  <span class="value">{{orderDetailData.attach }}</span>
                </div>
              </div>
              <el-empty v-else :image-size="200"></el-empty>
            </div>

            <div class="container_box_main_content" v-if="selectMainTab==2">
              <div v-if="orderDetailData.invoiceResult" class="info-grid">
                <div class="info-item">
                  <span class="label">成交时间：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.completedTime) }}</span>
                </div>
                <div class="info-item">
                  <span class="label">发票代码：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.invoiceCode)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">发票号码：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.invoiceNum)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">开票日期：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.invoiceDate) }}</span>
                </div>
                <div class="info-item">
                  <span class="label">购方名称：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.buyerName)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">证件类型：</span>
                  <span class="value">{{orderDetailData.invoiceResult.certificateType | certificateTypeFormatter}}</span>
                </div>
                <div class="info-item">
                  <span class="label">证件号码：</span>
                  <span class="value sensitive-data" @click="toggleSensitiveInfo(orderDetailData.orderCode, 'invoice_certificate')">
                    <span v-if="shouldShowSensitiveInfo(orderDetailData.orderCode, 'invoice_certificate')">
                      {{orderDetailData.invoiceResult.certificateNum}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                    <span v-else>
                      {{maskCertificate(orderDetailData.invoiceResult.certificateNum)}}
                      <i class="el-icon-view sensitive-icon"></i>
                    </span>
                  </span>
                </div>
                <div class="info-item">
                  <span class="label">价税合计：</span>
                  <span class="value">{{emptyToLine(orderDetailData.invoiceResult.priceTaxAmount)}}元</span>
                </div>
                <div class="info-item">
                  <span class="label">车架号：</span>
                  <span class="value">{{emptyToLine(orderDetailData.vin)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">购车用途：</span>
                  <span class="value">{{orderDetailData.invoiceResult.purchasePurposeDesc }}</span>
                </div>
                <div class="info-item">
                  <span class="label">车辆性质：</span>
                  <span class="value">{{emptyToLine(orderDetailData.vehiclePropertyDesc)}}</span>
                </div>
                <div class="info-item">
                  <span class="label">延迟成交理由：</span>
                  <span class="value">{{emptyToLine(orderDetailData.noDeliveryCarReason)}}</span>
                </div>
                <div class="info-item full-width">
                  <span class="label">发票：</span>
                  <span class="value">
                    <el-image :src="orderDetailData.invoiceResult.invoiceUrl" alt="" style="width: 150px;height: 150px;" :preview-src-list="[orderDetailData.invoiceResult.invoiceUrl]"></el-image>
                  </span>
                </div>
              </div>
              <el-empty v-else :image-size="200"></el-empty>
            </div>

            <div class="client_itinerary" v-if="selectMainTab==3" v-loading="false">
              <span v-if="Object.keys(carSaleOrderLoggerResult).length>0">
                <el-timeline>
                  <el-timeline-item :timestamp="item.completeTime" placement="top" v-for="(item, key) in carSaleOrderLoggerResult" :key="key">
                    <el-card>
                      <div v-if="item.orderSource" style="color: #595959;font-size: 14px;line-height: 30px">下订来源: {{item.orderSource}}</div>
                      <div v-if="item.saleConsultantName" style="color: #595959;font-size: 14px;line-height: 30px"> 销售顾问 : {{ item.saleConsultantName }}</div>
                      <div v-if="item.remark" style="color: #595959;font-size: 14px;line-height: 30px"> 备注 : {{ item.remark }}</div>
                    </el-card>
                  </el-timeline-item>
                </el-timeline>
              </span>
              <el-empty v-if="Object.keys(carSaleOrderLoggerResult).length<1" :image-size="200"></el-empty>
            </div>
          </el-main>
        </el-container>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
/* eslint-disable */
import Template from "@/views/dashboard/template.vue";
import {
  emptyToLine,
} from "@/utils/common";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Template },
  filters:{
    orderTypeFormatter(orderType){
      switch (orderType){
        case 0:
          return '手动下订'
        case 1:
          return '商城订单'
      }
      return '--'
    },
    genderFormatter(gender){
      switch (gender){
        case 1:
          return '男'
        case 2:
          return '女'
      }
      return '未知'
    },
    orderStatusFormatter(orderStatus){
      switch (orderStatus){
        case 1:
          return '待交车'
        case 2:
          return '交车'
        case 3:
          return '成交'
        case 4:
          return '已退订'
        case 5:
          return '已退货'
        case 6:
          return '退订审批中'
        case 7:
          return '退货审批中'
      }
      return '--'
    },
    maritalStatusFormatter(maritalStatus){
      switch (maritalStatus){
        case 10:
          return '未婚'
        case 20:
          return '已婚'
        case 30:
          return '丧偶'
        case 40:
          return '离婚'
        case 90:
          return '未说明婚姻状况'
      }
      return '--'
    },
    educationLevelFormatter(educationLevel){
      switch (educationLevel){
        case 11:
          return '硕士'
        case 12:
          return '博士'
        case 13:
          return '博士后'
        case 20:
          return '本科'
        case 30:
          return '专科'
        case 40:
          return '中专/技校/职高'
        case 60:
          return '高中'
        case 70:
          return '初中'
        case 80:
          return '小学'
        case 90:
          return '其他'
      }
      return '--'
    },
    incomeLevelFormatter(incomeLevel){
      switch (incomeLevel){
        case 1:
          return '5万以下'
        case 2:
          return '5-10万'
        case 3:
          return '10-15万'
        case 4:
          return '15-20万'
        case 5:
          return '20-25万'
        case 6:
          return '25-30万'
        case 7:
          return '30-35万'
        case 8:
          return '35万以上'
        case 9:
          return '未知'
      }
      return '--'
    },
    businessTypeFormatter(businessType){
      switch (businessType) {
        case 1:
          return '农、林、牧、渔业'
        case 2:
          return '采矿业'
        case 3:
          return '制造业'
        case 4:
          return '电力、燃气及水的生产和工业业'
        case 5:
          return '建筑业'
        case 6:
          return '交通运输、仓储和邮政业'
        case 7:
          return '信息传输、计算机服务和软件业'
        case 8:
          return'批发和零售业'
        case 9:
          return '住宿和餐饮业'
        case 10:
          return '金融业'
        case 11:
          return '房地产业'
        case 12:
          return '租赁和商务服务业'
        case 13:
          return '科学研究、技术服务和地址勘察业'
        case 14:
          return '水利、环境和公共设施管理业'
        case 15:
          return '居民服务和其他服务业'
        case 16:
          return '教育'
        case 17:
          return '卫生、社会保障和社会福利业'
        case 18:
          return '文化、体育和娱乐业'
        case 19:
          return '公共管理和社会组织'
        case 20:
          return '国际组织'
        case 21:
          return '其他'
      }
    },
    depositTypeFormatter(depositType){
      switch (depositType){
        case 1:
          return '意向金'
        case 2:
          return '小订'
        case 3:
          return '大订'
      }
      return '--'
    },
    certificateTypeFormatter(certificateType){
      switch (certificateType){
        case 1:
          return '身份证'
        case 2:
          return '军官证'
        case 3:
          return '港澳台海外地区证件'
        case 4:
          return '企业统一社会信用代码'
      }
      return '--'
    },
    paymentTypeFormatter(paymentType){
      switch (paymentType){
        case 1:
          return '分期付款'
        case 2:
          return '一次付清'
        case 3:
          return '线上定金'
      }
      return '--'
    }
  },
  data() {
    //这里存放数据
    return {
      listData: [], //列表数据
      listLoading: false, //列表loading
      detailListLoading: false, //详情列表loading
      tabList: [],  //标签数据
      selectTab: "1", //标签已选数据
      selectMainTab: "1", //客户信息标签选择
      groupBtnData: "0", //旅程自定义tabs当前选中
      operBtnText: '展开',
      operBtnClas: 'el-icon-arrow-down el-icon--down',
      operBtnFlag : false,
      // 搜索数据
      searchData: {
        searchKeyword: "",
        vin: "",
        orderStatus: null,
        orderType: null,
        depositStartTime:  "",
        depositEndTime:  "",
        cancelDepositStartTime:  "",
        cancelDepositEndTime:  "",
        returnCarAuditRejectStartTime:  "",
        returnCarAuditRejectEndTime:  "",
        offlineChargebacks: null,
        saleConsultantName:  "",
        dealerName: ""
      },
      customerTotal: '',      //客户数量
      searchKey: "customerName", //下拉input所选Key
      // 表格column数据，重新定义，只保留关键数据
      columnData: [
        { label: "订单编号", width: 170, prop: "orderCode" },
        { label: "客户姓名", width: 100, prop: "customerName" },
        // { label: "性别", width: 60, prop: "gender" },
        { label: "手机", width: 120, prop: "phone" },
        // { label: "证件号", width: 180, prop: "certificateNumber" },
        { label: "下订车型", width: 180, prop: "carModelName" },
        { label: "成交车型", width: 180, prop: "completedCarModelName" },
        { label: "订单状态", width: 110, prop: "orderStatus" },
        { label: "订单类型", width: 100, prop: "orderType" },
        { label: "销售顾问", width: 100, prop: "saleConsultantName" },
        { label: "下订日期", width: 130, prop: "depositTime" },
        { label: "交车时间", width: 120, prop: "deliveryTime" },
        { label: "是否线下退单", width: 100, prop: "offlineChargebacks" },
        { label: "退订审核通过时间", width: 160, prop: "cancelDepositTime" },
        { label: "退货审核通过日期", width: 160, prop: "returnCarAuditPassTime" }
      ],
      userInfoDrawer: false, //用户信息抽屉状态
      carSaleOrderLoggerResult: [],
      orderDetailData: {},    //客户详情

      orderDialogVisible: false,    //订单详情弹窗状态
      orderTabSelect: "order",      //订单弹窗tab
      itineraryPageNum: 1,          //客户旅程当前页码
      itineraryPage: 0,             //客户旅程总页数
      params: {}, // 用于存储当前分页参数
      showSensitiveInfo: {}, // 存储是否显示敏感信息的状态
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 订单编号列
    orderCodeColumn() {
      return this.columnData.find(item => item.prop === 'orderCode') || null;
    },
    // 订单类型列
    orderTypeColumn() {
      return this.columnData.find(item => item.prop === 'orderType') || null;
    },
    // 订单状态列
    orderStatusColumn() {
      return this.columnData.find(item => item.prop === 'orderStatus') || null;
    },
    // 其他需要显示的列（排除已单独处理的列）
    visibleColumns() {
      return this.columnData.filter(item =>
        item.prop !== 'orderCode' &&
        item.prop !== 'orderType' &&
        item.prop !== 'orderStatus'
      );
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    emptyToLine,
    // 页面列表翻页
    pageHandler(params, num) {
      this.params = params; // 保存当前分页参数，用于后续查询
      this.getOrderList(params, num ? num : params.pageNum, params.pageSize);
    },
    // 重置搜索数据
    resetSearchData(e) {
      this.searchData = {
        searchKeyword: "",
        vin: "",
        orderStatus: null,
        orderType: null,
        depositStartTime:  "",
        depositEndTime:  "",
        cancelDepositStartTime:  "",
        cancelDepositEndTime:  "",
        returnCarAuditRejectStartTime:  "",
        returnCarAuditRejectEndTime:  "",
        offlineChargebacks: null,
        saleConsultantName:  "",
        dealerName: "",
        deliveryStartTime: "",
        deliveryEndTime: "",
      }
    },
    operBtnHandle() {
      this.operBtnFlag = !this.operBtnFlag;
      if(this.operBtnFlag) {
        this.operBtnText = '收起';
        this.operBtnClas = 'el-icon-arrow-up el-icon--up';
        // 展开后滚动到新增的筛选项
        setTimeout(() => {
          const advancedSearch = document.querySelector('.advanced-search');
          if (advancedSearch) {
            advancedSearch.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }, 100);
      } else {
        this.operBtnText = '展开';
        this.operBtnClas = 'el-icon-arrow-down el-icon--down';
      }
    },

    // 点击客户展开详细信息
    openUserInfoFn(row) {
      this.selectTab = "1"; //标签已选数据
      this.selectMainTab = "1"; //客户信息标签选择
      this.groupBtnData = "0"; //旅程自定义tabs当前选中
      this.clueList = [];
      this.flowList = [];
      this.driveList = [];
      this.orderList = [];
      this.userInfoDrawer = true;
      this.itineraryPageNum = 1;          //客户旅程当前页码
      this.itineraryPage = 0;             //客户旅程总页数
      this.clientItineraryList = {};      //客户旅程数据
      // 获取客户客户详情
      this.getClientDetail(row.orderCode||"")
    },
    // 客户信息tab点击
    maintabHandleClick(e){
      this.selectMainTab = e.name;
      switch (e.name) {
        case "1":
          break;
        case "2":
          break;
        case "3":
          this.carSaleOrderLoggerResult = [];
          if(this.orderDetailData.orderLoggers){
            this.orderDetailData.orderLoggers.forEach(item => {
              var ext = JSON.parse(item.extJson)
              this.carSaleOrderLoggerResult.push({...ext})
            });
          }
          break;
        default:
          break;
      }
    },

    /**
     * 接口方法
     */

    updateUserFn(){
      this.$store.dispatch('newCarUser/getCarSaleOrderUpdate',{}).then(res => {
        this.$message.success('更新任务后台运行中，请稍后查看')
      })
    },
    // 获取用户列表
    getOrderList(params,pageNum,pageSize) {
      this.listLoading = true;
      var param  = {...this.searchData}

      if(this.searchData.depositStartTime){
        param.depositEndTime = this.searchData.depositStartTime[1]
        param.depositStartTime = this.searchData.depositStartTime[0]
      }

      if(this.searchData.cancelDepositStartTime){
        param.cancelDepositEndTime = this.searchData.cancelDepositStartTime[1]
        param.cancelDepositStartTime = this.searchData.cancelDepositStartTime[0]
      }

      if(this.searchData.returnCarAuditRejectStartTime){
        param.returnCarAuditRejectEndTime = this.searchData.returnCarAuditRejectStartTime[1]
        param.returnCarAuditRejectStartTime = this.searchData.returnCarAuditRejectStartTime[0]
      }

      if(this.searchData.deliveryStartTime){
        param.deliveryStartTime = this.searchData.deliveryStartTime[0]
        param.deliveryEndTime = this.searchData.deliveryStartTime[1]
      }
      this.$store.dispatch('newCarUser/getCarSaleOrderList',{
        ...param,
        stage: this.selectTab,
        pageNum,
        pageSize
      }).then(res => {
        if(res.code == 0){
          this.listData = res.data.list;
          params.render(res.data.total);
          this.customerTotal = res.data.total;
        }
        this.listLoading = false;
      })
    },

    // 获取唯一线索详情
    getClientDetail(orderCode) {
      this.listLoading = true;
      this.$store.dispatch('newCarUser/getCarSaleOrderDetail',{
        orderCode:orderCode
      }).then(res => {
        if(res.code == 0){
          this.orderDetailData = res.data
        }
        this.listLoading = false;
      })
    },

    // 获取订单状态样式类
    getStatusClass(status) {
      const statusMap = {
        "1": "status-primary", // 待交车
        "2": "status-success", // 已交车
        "3": "status-success", // 成交
        "4": "status-info", // 已退订
        "5": "status-info", // 已退货
        "6": "status-warning", // 退订审批中
        "7": "status-warning", // 退货审批中
      };
      return statusMap[status] || "status-default";
    },

    // 获取订单状态图标
    getStatusIcon(status) {
      const iconMap = {
        "1": "el-icon-time", // 待交车
        "2": "el-icon-circle-check", // 已交车
        "3": "el-icon-circle-check", // 成交
        "4": "el-icon-circle-close", // 已退订
        "5": "el-icon-circle-close", // 已退货
        "6": "el-icon-loading", // 退订审批中
        "7": "el-icon-loading", // 退货审批中
      };
      return iconMap[status] || "el-icon-info";
    },

    // 脱敏姓名
    maskName(name) {
      if (!name) return '--';
      if (name.length === 2) {
        return name.substring(0, 1) + '*';
      } else if (name.length > 2) {
        return name.substring(0, 1) + '*'.repeat(name.length - 2) + name.substring(name.length - 1);
      }
      return name;
    },

    // 脱敏证件号
    maskCertificate(certificate) {
      if (!certificate) return '--';
      if (certificate.length >= 10) {
        return certificate.substring(0, 4) + '*'.repeat(certificate.length - 8) + certificate.substring(certificate.length - 4);
      } else if (certificate.length > 6) {
        return certificate.substring(0, 3) + '*'.repeat(certificate.length - 6) + certificate.substring(certificate.length - 3);
      }
      return '*'.repeat(certificate.length);
    },

    // 脱敏手机号
    maskPhone(phone) {
      if (!phone) return '--';
      if (phone.length === 11) {
        return phone.substring(0, 3) + '****' + phone.substring(7);
      }
      return phone;
    },

    // 切换敏感信息显示状态
    toggleSensitiveInfo(id, type) {
      if (!this.showSensitiveInfo[id]) {
        this.showSensitiveInfo[id] = {};
      }
      this.showSensitiveInfo[id][type] = !this.showSensitiveInfo[id][type];
      this.$forceUpdate(); // 强制更新视图
    },

    // 判断是否显示敏感信息
    shouldShowSensitiveInfo(id, type) {
      return this.showSensitiveInfo[id] && this.showSensitiveInfo[id][type];
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // 初始化参数对象，避免模板中出现错误
    this.params = {
      pageNum: 1,
      pageSize: 10
    };
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  //生命周期 - 创建之前
  beforeCreate() {},
  //生命周期 - 挂载之前
  beforeMount() {},
  //生命周期 - 更新之前
  beforeUpdate() {},
  //生命周期 - 更新之后
  updated() {},
  //生命周期 - 销毁之前
  beforeDestroy() {},
  //生命周期 - 销毁完成
  destroyed() {},
  //如果页面有keep-alive缓存功能，这个函数会触发
  activated() {}
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
::v-deep .el-drawer{
  min-width: 1100px !important;
}

.page-icar-order {
  padding: 0 20px;

  @media (max-width: 767px) {
    padding: 0 10px;
  }

  .search-container {
    background-color: #fff;
    background-image: linear-gradient(to bottom, #f8f9fa 0%, #fff 8%);
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 15px;
    margin-bottom: 15px;
    transition: all 0.3s ease;

    @media (max-width: 767px) {
      padding: 10px;
      margin-bottom: 12px;
    }

    .search-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      position: relative;

      .search-icon {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background-color: #409eff;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 8px;

        i {
          font-size: 14px;
        }
      }

      .search-title {
        font-size: 15px;
        font-weight: 600;
        color: #303133;
      }

      .tabs-container {
        position: absolute;
        left: 100px;
        right: 0;

        ::v-deep .el-tabs__header {
          margin-bottom: 0;
        }

        ::v-deep .el-tabs__nav-wrap::after {
          display: none;
        }

        ::v-deep .el-tabs__item {
          height: 30px;
          line-height: 30px;
          padding: 0 15px;
          font-size: 13px;
        }

        ::v-deep .el-tabs__active-bar {
          height: 2px;
        }
      }
    }

    .search-wrapper {
      .search-form {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        position: relative;
      }

      ::v-deep .el-form-item {
        margin-bottom: 10px;
        margin-right: 10px;
        width: auto;

        @media (max-width: 1366px) {
          margin-right: 8px;
        }

        @media (max-width: 767px) {
          width: 100%;
          margin-right: 0;
        }
      }

      ::v-deep .el-form-item__label {
        padding: 0 8px 0 0;
        line-height: 32px;
        font-size: 13px;
      }

      ::v-deep .el-form-item__content {
        line-height: 32px;
      }

      ::v-deep .el-input__inner,
      ::v-deep .el-select .el-input__inner {
        width: 160px;
        border-radius: 4px;
        height: 32px;
        line-height: 32px;

        @media (max-width: 1366px) {
          width: 140px;
        }

        @media (max-width: 767px) {
          width: 100%;
        }
      }

      ::v-deep .el-date-editor--daterange.el-input__inner {
        width: 240px;

        @media (max-width: 1366px) {
          width: 220px;
        }

        @media (max-width: 767px) {
          width: 100%;
        }
      }

      ::v-deep .el-input__icon {
        line-height: 32px;
      }

      ::v-deep .el-button {
        border-radius: 4px;
        padding: 8px 15px;
        height: 32px;
      }

      .advanced-search {
        width: 100%;
        border-top: 1px dashed #ebeef5;
        margin-top: 5px;
        padding-top: 10px;

        @media (max-width: 767px) {
          padding-top: 5px;
        }
      }

      .search-actions {
        margin-left: auto;
        display: flex;
        align-items: center;

        @media (max-width: 767px) {
          width: 100%;
          justify-content: flex-end;
          margin-top: 5px;
        }

        .el-button {
          margin-left: 8px;
        }

        .expand-btn {
          margin-left: 8px;
          font-size: 13px;
          white-space: nowrap;

          i {
            margin-left: 3px;
            transition: transform 0.2s;
          }
        }
      }
    }
  }

  .main-container {
    .table {
      background-color: #fff;
      background-image: linear-gradient(to bottom, #f8f9fa 0%, #fff 6%);
      border-radius: 8px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
      padding: 15px;
      transition: all 0.3s ease;

      @media (max-width: 767px) {
        padding: 10px;
        overflow-x: auto;
      }

      .operate-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid #ebeef5;

        @media (max-width: 767px) {
          flex-direction: column;
          align-items: flex-start;

          .table-actions {
            margin-top: 10px;
            align-self: flex-end;
          }
        }

        .table-title {
          font-size: 15px;
          font-weight: 600;
          color: #303133;
          display: flex;
          align-items: center;

          i {
            margin-right: 5px;
            color: #409eff;
          }

          .count {
            font-size: 13px;
            font-weight: normal;
            color: #909399;
            margin-left: 8px;
          }
        }

        .table-actions {
          display: flex;
          gap: 10px;
        }
      }

      .icar-table {
        margin-bottom: 20px;

        ::v-deep .el-table {
          border-radius: 4px;
          overflow: hidden;
          border: none;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
        }

        ::v-deep .el-table::before {
          display: none; /* 移除底部边框 */
        }

        ::v-deep .el-table__header th {
          background-color: #f5f7fa;
          color: #606266;
          font-weight: 600;
          font-size: 13px;
          padding: 8px 0;
          border-bottom: 1px solid #ebeef5;
        }

        ::v-deep .el-table__row {
          font-size: 13px;
          transition: all 0.2s ease;
        }

        ::v-deep .el-table__row td {
          border-bottom: 1px solid #f0f2f5;
          padding: 10px 0;
        }

        ::v-deep .el-table__row:hover {
          background-color: #f5f7fa;
          transform: translateY(-1px);
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }

        ::v-deep .el-table--border,
        ::v-deep .el-table--group {
          border: none;
        }

        ::v-deep .el-table--border::after,
        ::v-deep .el-table--group::after {
          display: none;
        }

        ::v-deep .el-table--border .el-table__cell {
          border-right: none;
        }

        ::v-deep .el-table th.is-leaf {
          border-bottom: 1px solid #ebeef5;
        }

        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
          background: #fafafa;
        }

        /* 自定义分页器样式 */
        ::v-deep .el-pagination {
          padding: 15px 0 0;
          text-align: right;

          .btn-prev,
          .btn-next {
            border-radius: 4px;
            padding: 0 8px;
            background: #f5f7fa;
            border: 1px solid #ebeef5;

            &:hover {
              color: #409eff;
              background: #ecf5ff;
            }
          }

          .el-pager li {
            border-radius: 4px;
            padding: 0 12px;
            margin: 0 2px;
            border: 1px solid #ebeef5;

            &:hover {
              color: #409eff;
            }

            &.active {
              background-color: #409eff;
              color: #fff;
              border-color: #409eff;
            }
          }

          .el-pagination__sizes {
            margin-right: 15px;

            .el-input__inner {
              border-radius: 4px;
            }
          }
        }

        .order-no-cell {
          display: flex;
          align-items: center;
          cursor: pointer;
          padding: 2px 5px;
          border-radius: 4px;
          transition: all 0.2s ease;
          position: relative;
          margin-right: 15px;

          .no-text {
            color: #409eff;
            font-weight: 600;
          }

          .view-detail-icon {
            position: absolute;
            right: -15px;
            font-size: 12px;
            color: #909399;
            opacity: 0;
            transition: all 0.2s ease;
          }

          &:hover {
            background-color: #ecf5ff;

            .view-detail-icon {
              opacity: 1;
              right: -12px;
            }

            .no-text {
              text-decoration: underline;
            }
          }
        }

        .detail-link {
          font-size: 13px;
          color: #409eff;
        }
      }
    }
  }

  // 保留原有容器样式，但优化一些细节
  .container_box {
    background: #f5f7fa;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;

    .container_box_head {
      .label {
        color: #606266;
        line-height: 30px;
        font-size: 13px;
      }

      .value {
        color: #303133;
        font-size: 13px;
        font-weight: 400;
        line-height: 30px;
      }
      background: #fff;
      margin-bottom: 20px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 20px;
      box-sizing: border-box;
      height: auto;
      border-radius: 8px;
    }

    .container_box_main {
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 0 !important;
      border-radius: 8px;

      .container_box_main_tabs{
        margin-left: -1px;
      }

      .container_box_main_content{
        padding: 0 20px 20px 20px;
        box-sizing: border-box;

        .label {
          color: #606266;
          line-height: 30px;
          font-size: 13px;
        }

        .value {
          color: #303133;
          font-size: 13px;
          font-weight: 400;
          line-height: 30px;
        }
      }

      // 客户旅程
      .client_itinerary{
        padding: 10px 30px;
        box-sizing: border-box;
        max-height: 500px;
        overflow-y: auto;
      }
    }
  }
}

/* 状态样式 */
.order-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);
  }

  .status-icon {
    margin-right: 4px;
    font-size: 14px;
  }

  &.status-default {
    background-color: #f2f6fc;
    color: #909399;
    border-color: #ebeef5;
  }

  &.status-primary {
    background-color: #ecf5ff;
    color: #409eff;
    border-color: #d9ecff;
    position: relative;

    &::before {
      content: "";
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 14px;
      border: 2px solid #409eff;
      opacity: 0;
      animation: pulse 2s infinite;
    }

    .el-icon-loading {
      animation: rotating 1.5s linear infinite;
    }
  }

  &.status-success {
    background-color: #f0f9eb;
    color: #67c23a;
    border-color: #e1f3d8;
  }

  &.status-warning {
    background-color: #fdf6ec;
    color: #e6a23c;
    border-color: #faecd8;
  }

  &.status-danger {
    background-color: #fef0f0;
    color: #f56c6c;
    border-color: #fde2e2;
  }

  &.status-info {
    background-color: #f4f4f5;
    color: #909399;
    border-color: #e9e9eb;
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }
  50% {
    transform: scale(1.05);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 保留原有Tabs样式
::v-deep .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border: none;
  border-radius: 0;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-top: 3px solid transparent;
  box-sizing: border-box;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-left: 1px solid #dcdee0;
  border-right: 1px solid #dcdee0;
  border-top: 3px solid #2278f5;
  box-sizing: border-box;
}

::v-deep .el-timeline-item__timestamp {
  font-size: 14px !important;
  color: #505d69 !important;
  font-weight: 600;
  margin-bottom: 15px;
}

::v-deep .el-timeline .el-timeline-item:last-child .el-timeline-item__tail {
  display: initial !important;
}

::v-deep .el-timeline:last-child .el-timeline-item:last-child .el-timeline-item__tail {
  display: none !important;
}

::v-deep .el-timeline-item__wrapper {
  padding-left: 40px !important;
}

::v-deep .el-timeline-item__content {
  font-size: 13px;
}

/* 添加滚动美化 */
.client_itinerary::-webkit-scrollbar {
  width: 6px;
}

.client_itinerary::-webkit-scrollbar-track {
  background: #f5f7fa;
  border-radius: 10px;
}

.client_itinerary::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 10px;
}

.client_itinerary::-webkit-scrollbar-thumb:hover {
  background: #c0c4cc;
}

/* 添加过渡动画 */
.el-collapse-transition {
  transition: 0.3s height ease-in-out, 0.3s padding-top ease-in-out, 0.3s padding-bottom ease-in-out;
}

/* 优化抽屉组件样式 */
.order-detail-drawer {
  ::v-deep .el-drawer {
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .el-drawer__body {
      padding: 0;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    padding-bottom: 10px;
    display: flex;
    align-items: center;

    i {
      margin-right: 5px;
      color: #409eff;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;

    @media (max-width: 1366px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
    }

    .info-item {
      display: flex;
      align-items: flex-start;

      &.full-width {
        grid-column: 1 / -1;
      }

      .label {
        color: #606266;
        min-width: 100px;
        font-size: 13px;
        margin-right: 5px;
      }

      .value {
        color: #303133;
        font-size: 13px;
        word-break: break-all;

        &.highlight {
          color: #409eff;
          font-weight: 500;
        }
      }
    }
  }

  // 保持原有容器样式，但优化一些细节
  .container_box {
    background: #f5f7fa;
    height: 100%;
    padding: 20px;
    box-sizing: border-box;

    .container_box_head {
      background: #fff;
      margin-bottom: 20px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 20px;
      box-sizing: border-box;
      height: auto;
      border-radius: 8px;
    }

    .container_box_main {
      background: #fff;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
      padding: 0 !important;
      border-radius: 8px;

      .container_box_main_tabs{
        margin-left: -1px;
      }

      .container_box_main_content{
        padding: 20px;
        box-sizing: border-box;
      }

      // 客户旅程
      .client_itinerary{
        padding: 10px 30px;
        box-sizing: border-box;
        max-height: 500px;
        overflow-y: auto;

        ::v-deep .el-card {
          margin-bottom: 10px;
          border-radius: 8px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

          .el-card__body {
            padding: 15px;
          }
        }
      }
    }
  }
}

/* 敏感信息样式 */
.sensitive-data {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding-right: 20px;
  transition: all 0.2s ease;

  &:hover {
    color: #409eff;
  }

  .sensitive-icon {
    //position: absolute;
    right: 0;
    font-size: 14px;
    color: #909399;
    opacity: 0.7;
    transition: all 0.2s ease;
  }

  &:hover .sensitive-icon {
    color: #409eff;
    opacity: 1;
  }
}

.el-table {
  .sensitive-data {
    padding-right: 18px;

    .sensitive-icon {
      font-size: 12px;
    }
  }
}
</style>

